const roles = [
    { seq: 1, name: 'Owner' },
    { seq: 5, name: 'User' }
];
export { roles };
